<template>
    <div>
        <b-card title="ADD INVENTORY">

            <div v-if="items_being_loaded">
                <loading
                    :active="true"
                    :can-cancel="false"
                    :is-full-page="false">
                </loading>
            </div>

            <div v-else-if="items_being_loaded == false">
                <vue-simple-suggest
                    v-model="keyword"
                    display-attribute="product_name"
                    value-attribute="product_id_product_sku"
                    :max-suggestions=200
                    :list="searchProducts"
                    :filter-by-query="false"
                    @select="add_to_cache"
                    :min-length="2"
                    ref="product_sku"
                    style="margin-bottom: 10px; font-size: 16px; font-family: monospace; max-width: 500px; width: 100%; border: 1px solid black;"
                    class="input-field"
                >
                    <div slot="suggestion-item" slot-scope="{ suggestion, autocomplete }">
                        <span>
                            {{ suggestion.product_name }} [{{suggestion.product_sku}}]
                        </span>
                    </div>
                </vue-simple-suggest>
            </div>
        </b-card>

        <div v-if="items_to_add.length > 0">
            <b-card v-for="item,idx in items_to_add" v-bind:key="idx" class="p-1 p-lg-3">
                <div v-if="item.loading == true">
                    <loading
                        :active="true"
                        :can-cancel="false"
                        :is-full-page="false"
                    >
                    </loading>
                </div>

                <div v-else style="overflow-x: auto;">
                    <table style="width: 100%;">
                        <thead>
                            <tr style="background: gray; color: white;">
                                <th class="ipt_tdhr" style="min-width: 150px;">
                                    PRODUCT NAME
                                </th>
                                <th class="ipt_tdhr" style="min-width: 150px;">
                                    PRODUCT SKU
                                </th>
                                <th class="ipt_tdhr" style="min-width: 200px;">
                                    TARGET LOCATION
                                </th>
                                <th class="ipt_tdhr" style="min-width: 50px;">
                                    QUANTITY
                                </th>
                                <th class="ipt_tdhr" style="min-width: 70px;">
                                    IN STOCK
                                </th>
                                <th class="ipt_tdhr" style="min-width: 50px;">
                                    RESERVED
                                </th>
                                <th class="ipt_tdhr" style="min-width: 50px;">
                                    AVAILABLE
                                </th>
                                <th class="ipt_tdhr" style="min-width: 50px;">
                                    ACTION
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="ipt_tdr">
                                    {{ item.product_name }}
                                </td>
                                <td class="ipt_tdr">
                                    {{ item.product_sku }}
                                </td>
                                <td class="ipt_tdr">
                                    <b-form-select size="sm" :options="packet.locsubs.filter(loc => ![44,46,47].includes(loc.location_id))"
  v-model="item.locsub">

                                    </b-form-select>
                                </td>
                                <td class="ipt_tdr">
                                    <b-input size="sm" v-model="item.quantity" type="number" style="text-align: center;"></b-input>
                                </td>
                                <td class="ipt_tdr">
                                    {{ item.in_stock }}
                                </td>
                                <td class="ipt_tdr">
                                    {{ item.reserved }}
                                </td>
                                <td class="ipt_tdr">
                                    {{ item.available }}
                                </td>
                                <td class="ipt_tdr">
                                    <b-button size="sm" variant="success" @click="add_product_to_inventory(item)">ADD</b-button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </b-card>
        </div>
    </div>


</template>

<script>

    import moment from 'moment'
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import Requestor from '@/utilities/Requestor';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';

    import ItemComments from '@/components/importables/ItemComments'
    import VueSimpleSuggest from 'vue-simple-suggest'
    import 'vue-simple-suggest/dist/styles.css' // Optional CSS

    export default {
        name: "AddInventory",
        data: function(){
            return {
                items: [],
                items_being_loaded: null,
                items_being_loaded_2: null,
                keyword: '',
                items_to_add: []
            }
        },
        components: {VueSimpleSuggest,ItemComments,Loading},
        methods: {
               searchProducts: async function(query) {
        if (!query || query.length < 2) {
            return []; // Don't search for very short queries
        }

        let data = { search: query };
        let path = "/api/product/search_products_all/";
        let that = this;

        try {
            let response = await Requestor.getAsync(path, data);
            if (response.data.error) {
                console.error("Error searching products:", response.data.error);
                return [];
            }
            return response.data.result;
        } catch (error) {
            console.error("Error searching products:", error);
            return [];
        }
    },
            add_product_to_inventory: function(item){
                let data = item;

                if (!data.locsub){
                    this.$vex.dialog.alert({
                        message: "Please indicate a valid location to add inventory to."
                    });
                    return
                }

                let locsub = data.locsub.split("|");
                data.location_id = parseInt(locsub[0]);
                data.sublocation_id = parseInt(locsub[1]);
                data.nitems = parseInt(data.quantity);

                if(data.product_sku.replaceAll(/\s/g, "").length != data.product_sku.length){
                    this.$vex.dialog.alert({
                        message: "Invalid product sku."
                    });
                    return
                }

                if (!data.nitems){
                    this.$vex.dialog.alert({
                        message: "Please indicate a valid quantity to add."
                    });
                    return
                }

                data.product_sku = data.product_sku.replaceAll(/\s/g, "");

                let that = this;
                let path =  "/api/inventory/add_single_product_to_inventory/"
                let s = function(response) {
                    if (response.data.error){
                        
                        that.$bvToast.toast(
                            "ERROR ADDING ITEM TO INVENTORY.",
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );

                    }
                    else {
                        // that.$bvToast.toast(
                        //     "ADDED TO INVENTORY.",
                        //     {title: "Success", autoHideDelay: 1500, variant:"success"}
                        // );
                        that.$vex.dialog.alert({
                            message: "ADDED "+ item.product_name+" TO ("+ that.packet.locsubsdict[item.locsub]+") INVENTORY."
                        });
                        that.items_to_add = that.items_to_add.filter(function(d){
                            return d.idx != item.idx;
                        });
                    }
                    item.loading = false;
                }

                let f = function(error) {
                    that.$bvToast.toast(
                        "AN ERROR OCCURRED ADDING ITEM TO INVENTORY. PLEASE TRY AGAIN LATER.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    item.loading = false;
                }

                item.loading = true;
                Requestor.postAsync(path, data, s, f);

            },
            fetch_init: function(){
                let data = {}
                let path = "/api/product/get_product_list_v4/"
                let that = this;
                let s = function(response) {
                    if (response.data.error){
                        that.$bvToast.toast(
                            "ERROR RETRIEVING PRODUCT LIST",
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );

                    }
                    else {
                        that.items = response.data.result;
                    }
                    that.items_being_loaded = false;
                }

                let f = function(error) {
                    that.$bvToast.toast(
                        "Error retrieving products.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.items_being_loaded = false;
                }

                this.items_being_loaded = true;
                Requestor.getSyncP(path, data, this, s, f);
            },
            filter_products: function(item, query){
                return (
                    item.product_name.toLowerCase().indexOf(query.toLowerCase()) > -1
                    ||
                    item.product_sku.toLowerCase().indexOf(query.toLowerCase()) > -1
                )
            },
            add_to_cache: function(e) {
                let idx = this.items_to_add.length + 1;
                let item = {
                    product_name: e.product_name,
                    product_id: parseInt(e.product_id),
                    product_sku: e.product_sku,
                    locsub: null,
                    quantity: 0,
                    loading: null,
                    idx: idx,
                    username: this.packet.userDetails.username,
                    add_log: true,
                    available: e.available,
                    in_stock:e.in_stock,
                    reserved:e.reserved
                }

                this.items_to_add.push(item);
            },
        },
        created: function(){
            this.packet = JSON.parse(localStorage.packet);
            this.packet.userDetails = JSON.parse(localStorage.userDetails);
            this.fetch_init()
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Inventory/AddInventory.vue